import { useState, useEffect } from 'react';

const VISIT_KEY = 'tool_visits';
const REDIRECT_URL = 'https://kronologic.me/1-click/zWxqVT2ASOytpMCtSReRDWxbBRVHiUbHjzqAm5x3Arg';

export function useVisitTracker(toolId: string) {
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    const visits = JSON.parse(localStorage.getItem(VISIT_KEY) || '{}');
    const toolVisits = visits[toolId] || 0;
    
    visits[toolId] = toolVisits + 1;
    localStorage.setItem(VISIT_KEY, JSON.stringify(visits));

    if (toolVisits >= 2) { // Redirect after 3rd visit (index starts at 0)
      setShouldRedirect(true);
      window.location.href = REDIRECT_URL;
    }
  }, [toolId]);

  return shouldRedirect;
}